<template>
  <div class="fliggy-order-detail-dialog">
    <el-dialog
      class="add-order-modal"
      v-model="visible"
      :close-on-click-modal="false"
      top="50%"
      title="飞猪订单信息"
      @close="onClose"
    >
      <div class="dialog-header">
        <div class="header-title">飞猪订单信息</div>
        <div class="shop-info">
          <img src="../../../assets/imgs/ota-order/fliggy.png"  class="fliggy-logo">
          <div class="fliggy-name" v-if="otaOrderInfo">{{otaOrderInfo.ota_store_name}}</div>
        </div>
        <div class="icon-close" @click="visible = false">
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </div>
      </div>
      <div class="order-detail-body" v-if="otaOrderInfo">
        <div class="block-box">
          <div class="main-item-box">
            <div class="box-header">
              <span class="header-title">商品信息</span>
              <div class="header-right">
                <div class="error-tips" v-if="otaOrderInfo.alert_desc">{{otaOrderInfo.alert_desc}}</div>
                <button v-if="otaOrderInfo.alert_desc" class="s-btn btn-blue" @click.stop="onBindProduct">重新绑定商品</button>
              </div>
            </div>
            <div class="box-body">
              <div class="body-field">
                <label class="field-label">上上签商品信息</label>
                <p class="field-content">{{otaOrderInfo.visa_product_id}} {{otaOrderInfo.product_name}}</p>
              </div>
              <div class="body-field">
                <label class="field-label">上上签出签形式</label>
                <p class="field-content">{{otaOrderInfo.visa_form}}</p>
              </div>
              <div class="body-field">
                <label class="field-label">飞猪商品信息</label>
                <p class="field-content">{{otaOrderInfo.item_title}}</p>
              </div>
              <div class="body-field">
                <label class="field-label">飞猪套餐信息</label>
                <p class="field-content">{{otaOrderInfo.sku_properties}}</p>
              </div>
              <div class="body-field">
                <label class="field-label">飞猪出签形式</label>
                <p class="field-content">{{otaOrderInfo.visa_type}}</p>
              </div>
            </div>
          </div>

          <div class="main-item-box">
            <div class="box-header">
              <span class="header-title">飞猪订单信息</span>
            </div>
            <div class="box-body">
              <div class="body-field">
                <label class="field-label">飞猪订单号</label>
                <p class="field-content"><span class="content-subtitle">主订单</span>{{otaOrderInfo.ota_order_id}}<span class="content-subtitle left-border">子订单</span>{{params.ota_sub_order_id}}</p>
              </div>
              <div class="body-field">
                <label class="field-label">购买数量</label>
                <p class="field-content">{{otaOrderInfo.item_num}}</p>
              </div>
              <div class="body-field">
                <label class="field-label">订单状态</label>
                <p class="field-content">{{otaStatusMap[otaOrderInfo.ota_status]}}</p>
              </div>
              <div class="body-field">
                <label class="field-label">支付时间</label>
                <p class="field-content">{{otaOrderInfo.pay_time}}</p>
              </div>
            </div>
          </div>

          <div class="main-item-box">
            <div class="box-header">
              <span class="header-title">飞猪买家信息<span class="header-subtitle">*以下信息为顾客敏感信息，飞猪已加密处理，如需查看请登录飞猪后台</span></span>
            </div>
            <div class="box-body">
              <div class="body-field">
                <label class="field-label">联系人姓名</label>
                <p class="field-content">{{otaOrderInfo.name}}</p>
              </div>
              <div class="body-field">
                <label class="field-label">联系电话</label>
                <p class="field-content">{{otaOrderInfo.phone}}</p>
              </div>
              <!-- <div class="body-field">
                <label class="field-label">邮箱</label>
                <p class="field-content">{{otaOrderInfo.email}}</p>
              </div> -->
              <div class="body-field">
                <label class="field-label">收货地址</label>
                <p class="field-content">{{otaOrderInfo.address}}</p>
              </div>
              <div class="body-field">
                <label class="field-label">买家留言</label>
                <p class="field-content">{{otaOrderInfo.buyer_message}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Http from '@/libs/http';
import fliggyRebindProductDialog from '../fliggy-rebind-product-dialog/index';

export default {
  components: {},
  props: {},

  data() {
    return {
      params: {
        ota_sub_order_id: 0,
        resolve: null,
        reject: null,
        onClose: null,
        onRefresh: null,
      },
      visible: false,
      
      otaStatusMap: {
        2: '订单已付款',
        3: '订单已关闭',
        5: '交易成功',
      },
      otaOrderInfo: null,
    };
  },
  computed: {},
  created() {
    this.visible = true;
    this.init();
  },
  methods: {
    init() {
      if (!this.params.ota_sub_order_id) {
        this.visible = false;
        return;
      }
      this.getOtaOrder();
    },
    getOtaOrder() {
      return Http.post('/ota_order_query', { ota_sub_order_id: this.params.ota_sub_order_id }).then((data) => {
        this.otaOrderInfo = data;
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    onBindProduct() {
      fliggyRebindProductDialog.show({
        ota_sub_order_id: this.params.ota_sub_order_id,
      }).then(() => {
        // 修改成功，更新数据
        this.getOtaOrder();
        this.params.onRefresh && this.params.onRefresh();
      });
    },
    onClose() {
      setTimeout(() => {
        this.params.onClose && this.params.onClose();
        this.$destroy(true);
        if (this.$el.parentNode) this.$el.parentNode.removeChild(this.$el);
      }, 300);
    },
  },
};
</script>

<style lang="less" scoped>
.fliggy-order-detail-dialog{
  /deep/ .el-dialog{
    border-radius: 5px;
    margin: 0;
    transform: translate(-50%, -50%);
    .el-dialog__header{
      padding: 20px 24px;
      display: none;
    }
    .el-dialog__body{
      padding: 0;
    }
  }
  .dialog-header{
    height: 62px;
    display: flex;
    align-items: center;
    padding: 0 24px;
    border-bottom: 1px solid #E9EEF2;
    position: relative;
    .header-title{
      color: #2F333D;
      font-size: 20px;
      font-weight: 600;
    }
    .shop-info{
      margin-left: 10px;
      padding-left: 10px;
      border-left: 1px solid #DEE2E6;
      height: 16px;
      display: flex;
      align-items: center;
      .fliggy-logo{
        width: 16px;
      }
      .fliggy-name{
        margin-left: 4px;
        color: #2F333D;
        font-size: 14px;
        font-weight: 600;
      }
    }
    .icon-close{
      position: absolute;
      right: 24px;
      top: 50%;
      transform: translateY(-50%);
      color: #91999F;
      cursor: pointer;
    }
  }
  .order-detail-body{
    max-height: calc(~'80vh - 40px');
    overflow: auto;
    padding: 24px;
    .block-box{
      .main-item-box {
        margin-bottom: 20px;
        background-color: #ffffff;
        box-shadow: 0px 1px 4px 0px rgba(0,0,0,0.1);
        border-radius: 4px;
        border: solid 1px #f0f0f0;
        .box-header {
          padding: 0 10px 0 20px;
          height: 52px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #f0f0f0;
          .header-title {
            font-size: 16px;
            font-weight: bold;
            color: #333;
            .header-subtitle {
              margin-left: 15px;
              font-size: 14px;
              font-weight: normal;
              color: #aaa;
            }
          }
          .header-right{
            display: flex;
            align-items: center;
            .error-tips{
              padding: 0 20px 0 24px;
              height: 40px;
              line-height: 40px;
              color: #ff5a60;
              font-size: 14px;
              background-image: url('https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/order/fliggy/icon-error-tips.png');
              background-repeat: no-repeat;
              background-size: 16px 16px;
              background-position: left center;
            }
            .s-btn{
              height: 28px;
              border: 4px;
              padding: 0 12px;
            }
          }
        }
        .box-body {
          padding: 20px;
          .body-field {
            display: flex;
            margin-bottom: 10px;
            &:last-child{
              margin-bottom: 0;
            }
            .field-label {
              width: 130px;
              color: #777;
              font-size: 14px;
              line-height: 24px;
              flex-grow: 0;
              flex-shrink: 0;
            }

            .field-content {
              font-size: 14px;
              line-height: 24px;
              color: #2F333D;
              word-break: break-all;
              .content-subtitle {
                color: #aaa;
                margin-right: 10px;
                &.left-border::before {
                  content: "";
                  display: inline-block;
                  vertical-align: middle;
                  width: 1px;
                  height: 16px;
                  background-color: #cfcfcf;
                  margin-right: 20px;
                  margin-left: 20px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ota/fliggy-order-detail-dialog/fliggy-order-detail-dialog.vue